import { createClient } from '@supabase/supabase-js';

const url = import.meta.env.VITE_SUPABASE_URL as string;
const key = import.meta.env.VITE_SUPABASE_ANON_KEY as string;

export const supabase = createClient(url, key, {
  auth: {
    flowType: 'pkce',
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
    storageKey: 'brifing-web-auth',
  },
});

/** Edge fn hataları gövdede `{error}` taşır; supabase-js bunu context'te saklar. */
export async function unwrapFunctionError(error: unknown): Promise<Error> {
  const ctx = (error as { context?: Response }).context;
  if (ctx && typeof ctx.json === 'function') {
    try {
      const body = (await ctx.clone().json()) as { error?: string };
      if (body?.error) return new Error(body.error);
    } catch {
      // gövde JSON değil
    }
  }
  return error instanceof Error ? error : new Error(String(error));
}
